import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import EcoLink from 'eco-design/base/eco-link';
import { useLang } from '@/i18n';
import getLocal from 'eco-design-reliance/getLocal';

const ForumEntry: React.FC = () => {
    const { locale = 'us' } = getLocal();
    if (!['us'].includes(locale)) {
        return null;
    }
    const { t } = useLang('ForumEntry');
    const COMMUNITY_LINK = 'https://forum.ecoflow.com/us/sections/scenarios';

    return (
        <div
            className={`${css['forum-entry']} forum-entry GtmModuleData-section`}
            id="forum-entry"
            data-section-id=""
            data-section-title={t('forum-entry-title')}
        >
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1783329076157-kfmw7x-compressed-PC.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1783329088746-9fbrdk-compressed-Pad.jpg"
                    h5="https://websiteoss.ecoflow.com/figma-uploads/1783329099716-fln4zv-compressed-Mob.jpg"
                    alt={t('forum-entry-title')}
                />
                <div className="info">
                    <div className="info-head">
                        <EcoImg
                            className="avatar"
                            pc={'https://websiteoss.ecoflow.com/figma-uploads/1783327019930-f59sgl-compressed-Frame%201612707538.png'}
                            alt={t('forum-entry-btn')}
                        />
                        <span className="avatar-text">{t('forum-entry-text')}</span>
                    </div>
                    <h3 className="info-title">{t('forum-entry-title')}</h3>
                    <p className="info-desc">{t('forum-entry-desc')}</p>
                    <EcoLink
                        className="info-href GtmModuleData-btn-href"
                        href={COMMUNITY_LINK}
                        target="_blank"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'forum',
                            button_name: 'View More',
                            url: COMMUNITY_LINK,
                            __btn_id1: `forum-entry .info-href`,
                            __btn_id2: COMMUNITY_LINK,
                            __btn_type: 'href',
                        }}
                    >
                        <span>{t('forum-entry-btn')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                                d="M7.70765 7.08106C7.70764 6.66692 8.04345 6.33126 8.45756 6.33114L16.9794 6.33045C17.1782 6.33044 17.3692 6.40959 17.5098 6.55004C17.6504 6.69069 17.7301 6.88214 17.7301 7.08106L17.7294 15.4814C17.7294 15.8956 17.3937 16.2313 16.9794 16.2313C16.5654 16.2311 16.2295 15.8955 16.2295 15.4814L16.2295 8.89095L7.61028 17.5102C7.31739 17.8031 6.84251 17.8031 6.54962 17.5102C6.25707 17.2173 6.25684 16.7423 6.54962 16.4495L15.1682 7.83098L8.45756 7.83098C8.04353 7.83085 7.70777 7.49509 7.70765 7.08106Z"
                                fill="currentColor"
                            />
                        </svg>
                    </EcoLink>
                </div>
            </div>
        </div>
    );
};

export default ForumEntry;
